import { Avatar, Typography } from '@mui/material'
import React from 'react'

const CustomTitle = ({title,icon}) => {
  return (
    <>
    <Typography component="h1" variant="h3" sx={{ display: "flex", alignItems: "center", fontSize: '16px', fontFamily: 'BTitr !important',m:1}}>
    {(icon)&&(icon!==null)&&<Avatar sx={{ m: 1, bgcolor: 'secondary.main', color: 'secondary' }}>
      {icon}
    </Avatar>}
    {title}
  </Typography>
  <div style={{marginBottom:25,height:3,background:'#81B214',}}/>
  </>
  )
}

export default CustomTitle